import { render, staticRenderFns } from "./cobros_screen.vue?vue&type=template&id=9edbe5a6&scoped=true"
import script from "./cobros_screen.vue?vue&type=script&lang=js"
export * from "./cobros_screen.vue?vue&type=script&lang=js"
import style0 from "./cobros_screen.vue?vue&type=style&index=0&id=9edbe5a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edbe5a6",
  null
  
)

export default component.exports